import React from 'react'
import PropTypes from 'prop-types'

class LocationSelect extends React.Component {
  state = {
    location_id: this.props.location_id
  }

  onLocationChange = (e) => {
    this.setState({ location_id: e.target.value })
    setTimeout(function() { this.props.newLocationCallback(this.state.location_id) }.bind(this), 50)
  }

  render() {
    var options = this.props.locations.map(function(location) {
      return (
        <option key={location.id}
                value={location.id}>
          {location.name}
        </option>
      )
    })

    return(
      <div className={this.props.selectClassName}>
        <select className='form-control'
                title='Locations'
                value={this.state.location_id}
                onChange={(e) => this.onLocationChange(e)}>
          <option value=''>
            { this.props.selectPrompt || "All My Locations"}
          </option>
          {options}
        </select>
      </div>
    )
  }
}

LocationSelect.propTypes = {
  location_id: PropTypes.number,
  locations: PropTypes.array,
  selectClassName: PropTypes.string
}

export default LocationSelect
